import Phaser from 'phaser';
import { DEPTH } from './theme';

const BAR_W = 460;
const BAR_H = 16;

/**
 * BOSS 血条（屏幕固定，顶部居中）。
 *
 * 用法：每帧若存在 BOSS 就调用 update(name, hp, maxHp)，否则调用 hide()。
 * 血条按 hp/maxHp 实时收缩；hp 归零（血条清空）= BOSS 被击败
 * （GameScene 会 destroy 该 BOSS，随后本血条自动隐藏）。
 */
export default class BossBar {
  private root: Phaser.GameObjects.Container;
  private fill: Phaser.GameObjects.Rectangle;
  private nameText: Phaser.GameObjects.Text;
  private shown = false;
  private name = '';

  constructor(private readonly scene: Phaser.Scene) {
    const cx = scene.scale.width / 2;
    this.root = scene.add
      .container(cx, 40)
      .setScrollFactor(0)
      .setDepth(DEPTH.bossBar)
      .setVisible(false);

    const bg = scene.add
      .rectangle(0, 0, BAR_W, BAR_H, 0x000000, 0.7)
      .setStrokeStyle(2, 0xe74c3c, 0.9);
    // 原点在左端 → 通过 scaleX 从左侧开始收缩
    this.fill = scene.add
      .rectangle(-BAR_W / 2 + 2, 0, BAR_W - 4, BAR_H - 4, 0xe74c3c)
      .setOrigin(0, 0.5);
    this.nameText = scene.add
      .text(0, -18, '', { fontSize: '14px', fontFamily: 'monospace', color: '#ff9b8f' })
      .setOrigin(0.5);

    this.root.add([bg, this.fill, this.nameText]);
  }

  /** 每帧刷新（有 BOSS 时调用） */
  update(name: string, hp: number, maxHp: number) {
    if (!this.shown) {
      this.shown = true;
      this.scene.tweens.killTweensOf(this.root);
      this.root.setVisible(true).setAlpha(1);
    }
    if (name !== this.name) {
      this.name = name;
      this.nameText.setText(name);
    }
    const ratio = Phaser.Math.Clamp(maxHp > 0 ? hp / maxHp : 0, 0, 1);
    this.fill.scaleX = ratio;
  }

  /** BOSS 消失 / 被击败时调用（淡出后隐藏） */
  hide() {
    if (!this.shown) return;
    this.shown = false;
    this.name = '';
    this.scene.tweens.add({
      targets: this.root,
      alpha: 0,
      duration: 300,
      onComplete: () => this.root.setVisible(false),
    });
  }
}
